export const buildUrlWithParams = ({
  basePath,
  defaultParams = {},
  overrideParams = {},
}: {
  basePath: string;
  defaultParams?: Record<string, string | boolean | null | undefined>;
  overrideParams?: Record<string, string | boolean | null | undefined>;
}) => {
  const params = new URLSearchParams();

  const allParams = {
    ...defaultParams,
    ...overrideParams,
  };

  Object.entries(allParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.set(key, String(value));
    }
  });

  return `${basePath}?${params.toString()}`;
};
